import React, { useMemo } from "react";
import { connect, useSelector } from "react-redux";
import { getWidgetSpecificProps, getWidgetSpecificIsVisible } from "@utils/index";
import {
  Container,
  SlotsGrid,
  SlotChip,
} from "./styles";

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    ),
    ...getWidgetSpecificProps(
      state.configuration?.normalisedConfig,
      ownProps.id
    ),
  };
};

const TimeSlotSelector = (props: any) => {
  const { is_visible, slotsData = [], selectedSlot: propSelectedSlot, actions } = props;
  
  const { selectedDateFromPayload, selectedSlotFromPayload } = useSelector(({ globalState }: any) => ({
    selectedDateFromPayload: globalState?.payloadData?.selectedDate,
    selectedSlotFromPayload: globalState?.payloadData?.selectedSlot
  }));
  
  const selectedDate = selectedDateFromPayload;
  const selectedSlot = propSelectedSlot || selectedSlotFromPayload;
  
  const slots = useMemo(() => {
    if (slotsData?.length > 0 && selectedDate) {
      const selectedDateData = slotsData?.find((item: any) => item.date === selectedDate);
      return selectedDateData?.slots || [];
    }

    if ( slotsData?.length > 0) {
      return slotsData[0]?.slots || [];
    }
    return [];
  }, [slotsData, selectedDate]);

  if (!is_visible) return <></>;

  const handleSlotClick = (slot: string) => {
    actions?.on_slot_select?.forEach((action: any) => {
      if (action && typeof action.funCall === "function") {
        action.funCall({
          ...action.args,
          payloadData: {
            selectedSlot: slot
          }
        });
      }
    });
  };
  
  const fullState = useSelector((state: any) => state);
  console.log(fullState);
  
  return (
    <Container>
      {slots.length === 0 ? (
        <div style={{ 
          padding: "32px", 
          textAlign: "center", 
          color: "#555A68",
          fontSize: "14px" 
        }}>
          No slots available for this date
        </div>
      ) : (
        <SlotsGrid>
          {slots.map((slot: string, index: number) => {
            const isSelected = selectedSlot === slot;
            const slotStartLabel = slot.split(/\s*-\s*/)[0]?.trim() || slot;
            return (
              <SlotChip
                key={index}
                isActive={isSelected}
                onClick={() => handleSlotClick(slot)}
              >
                {slotStartLabel}
              </SlotChip>
            );
          })}
        </SlotsGrid>
      )}
    </Container>
  );
};

export default connect(mapStateToProps)(TimeSlotSelector);
